import React, { useRef, useState, useEffect } from "react";
import { Play, Pause } from "lucide-react";

interface SimpleMusicPlayerProps {
  song: {
    title: string;
    src: string;
    cover: string;
  };
}

const SimpleMusicPlayer: React.FC<SimpleMusicPlayerProps> = ({ song }) => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) audio.play().catch(() => {});
    else audio.pause();
  }, [isPlaying]);

  return (
    <div
    style={{
        width: 'clamp(80px, 30vw, 260px)',   // ⬅ smaller
        height: 'clamp(80px, 30vw, 260px)',  // ⬅ smaller
        maxWidth: "140px",
        maxHeight: "140px",
        borderRadius: "12px",
        overflow: "hidden",
        position: "relative",
        boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
    }}
    >
      <img
        src={song.cover}
        alt={song.title}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />

      {/* Play / Pause Overlay */}
      <button
        onClick={() => setIsPlaying((p) => !p)}
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,0.35)",
          border: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
      >     
        {isPlaying ? <Pause size={28} color="white" /> : <Play size={28} color="white" />}
      </button>

      <audio ref={audioRef} src={song.src} />
    </div>
  );
};

export default SimpleMusicPlayer;